module.exports = __webpack_public_path__ + "img/default-nav-subnav-nissan.3031b511.png";